import { Screen } from "../components/Screen";
import { Footer } from "../components/Footer";
import { CSSProperties, useEffect, useState } from "react";
import { Font } from "../constants/fonts";
import { Colors } from "../constants/colors";
import { Button } from "../components/Button";
import { useNavigate } from 'react-router-dom';

export default function Home() {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(false);
    
    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    if (isMobile) {
        return (
            <Screen>
                <div style={mobileStyles.container}>
                    <div style={mobileStyles.topSection}>
                        <img src="/LOGO%20TM%207.svg" alt="ClickMob logo" style={mobileStyles.logo}/>
                        <div style={mobileStyles.title}>
                            Mobilidade que conecta pessoas, valoriza motoristas e transforma cidades.
                        </div>
                        <div style={mobileStyles.legend}>
                            Um novo jeito de se mover, com empatia, segurança e benefícios reais para todos.
                        </div>
                        <img src="/image%2014.svg" alt="ClickMob logo" style={mobileStyles.mobileImage}/>
                    </div>
                    
                    <div style={mobileStyles.buttonSection}>
                        <Button
                            text="Conheça o ClickMob"
                            onClick={() => navigate('/como-funciona')}
                        />
                        <Button
                            text="Cadastre-se e receba novidades"
                            onClick={() => navigate('/contato')}
                        />
                    </div>
                    
                    <div style={mobileStyles.contentSection}>
                        <div style={mobileStyles.textContainer}>
                            <div style={mobileStyles.text}>
                                O ClikMob é um aplicativo de mobilidade urbana desenvolvido para criar uma experiência mais justa, segura e humana.  
                            </div>
                            <div style={mobileStyles.text}>
                                Aqui, motoristas e passageiros caminham juntos, com respeito, benefícios e tecnologia a favor da mobilidade inteligente.
                            </div>
                        </div>
                        <img src="/Rectangle%2026.svg" alt="ClickMob logo" style={mobileStyles.logo4}/>
                    </div>
                </div>
                <Footer/>
            </Screen>
        );
    }

    // Return original (desktop) intacto
    return (
        <Screen>
            <div style={styles.container}>
                <div style={styles.subContainer}>
                    <div>
                        <img src="/LOGO%20TM%207.svg" alt="ClickMob logo" style={styles.logo}/>
                        <div style={styles.title}>
                            Mobilidade que conecta pessoas, valoriza motoristas e transforma cidades.
                        </div>
                        <div style={styles.legend}>
                            Um novo jeito de se mover, com empatia, segurança e benefícios reais para todos.
                        </div>
                        <center>
                            <img src="/LOGO%20TM1.svg" alt="ClickMob logo" style={styles.logo2}/>
                        </center>
                    </div>
                </div>
                <div style={styles.subContainer2}>
                    <img src="/image%2014.svg" alt="ClickMob logo" style={styles.logo3}/>
                </div>
            </div>
            <div style={styles.container2}>
                <div style={styles.buttonContainer}>
                    <Button
                        text="Conheça o ClickMob"
                        onClick={() => navigate('/como-funciona')}
                    />
                    <Button
                        text="Cadastre-se e receba novidades"
                        onClick={() => navigate('/contato')}
                    />
                </div>
                <div style={styles.flexConteiner}>
                    <div style={styles.textContainer}>
                        <div style={styles.text}>
                            O ClikMob é um aplicativo de mobilidade urbana desenvolvido para criar uma experiência mais  justa, segura e humana.  
                        </div>
                        <div style={styles.text}>
                            Aqui, motoristas e passageiros caminham juntos, com respeito, benefícios e tecnologia a favor da mobilidade inteligente.
                        </div>
                    </div>
                     <img src="/Rectangle%2026.svg" alt="ClickMob logo" style={styles.logo4}/>
                </div>
            </div>
            <Footer/>
        </Screen>
    );
}

// Estilos desktop originais (mantidos intactos)
const styles:  { [key: string]: CSSProperties } = {
    logo: {
        height: 71,
        width: 'auto'
    },
    logo2: {
        maxWidth: '100%',
        height: 222,
        marginTop: 140
    },
    logo3: {
        height: '100%',
        marginLeft: -450
    },
    logo4: {
        width: '55%'
    },
    title: {
        fontSize: Font.title.fontSize,
        textAlign: 'justify',
        color: Colors.white,
        marginBottom: 20
    },
    legend: {
        fontSize: Font.legend.fontSize,
        textAlign: 'justify',
        color: Colors.white
    },
    text: {
        fontSize: Font.text.fontSize,
        textAlign: 'justify',
        color: Colors.primary
    },
    mainContaioner: {
        display: 'flex'   
    },
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        backgroundColor: Colors.primary,
        width: '100%',
        height: '100%'
    },
    subContainer: {
        width: '65%',
        height: '100%',
        padding: '100px 250px 50px 50px',
    },
    subContainer2: {
        height: '100%',
        width: '35%',
        backgroundColor: Colors.white,
        display: 'flex',
        alignItems: 'end'
    },
    container2: {
        backgroundColor: Colors.gray,
        justifyContent: 'center',
        padding: '80px 50px'
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 40,
        justifyContent: 'center',
        marginBottom: 60
    },
    flexConteiner: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 50
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 30,
        width: '40%'
    }
}

// Estilos mobile otimizados
const mobileStyles: { [key: string]: CSSProperties } = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: Colors.gray,
        minHeight: '100vh',
    },
    topSection: {
        backgroundColor: Colors.primary,
        padding: '40px 20px',
        textAlign: 'center',
    },
    logo: {
        height: 50,
        width: 'auto',
        marginBottom: 30,
    },
    title: {
        fontSize: Font.title.fontSize * 0.8,
        textAlign: 'center',
        color: Colors.white,
        marginBottom: 20,
        lineHeight: 1.3,
    },
    legend: {
        fontSize: Font.legend.fontSize * 0.9,
        textAlign: 'center',
        color: Colors.white,
        lineHeight: 1.4,
        marginBottom: 30,
    },
    mobileImage: {
        width: '100%',
        maxWidth: 350,
        height: 'auto',
        marginBottom: '-10%',
        display: 'block',
    },
    buttonSection: {
        padding: '40px 20px',
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        backgroundColor: Colors.gray,
    },
    button: {
        width: '100%',
    },
    contentSection: {
        padding: '40px 20px',
        backgroundColor: Colors.gray,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 40,
    },
    logo2: {
        width: '100%',
        maxWidth: 250,
        height: 'auto',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20,
        width: '100%',
    },
    text: {
        fontSize: Font.text.fontSize * 0.95,
        textAlign: 'center',
        color: Colors.primary,
        lineHeight: 1.5,
    },
    logo4: {
        width: '100%',
        maxWidth: 300,
        height: 'auto',
    },
};